import { type CollegeDetail } from "@/services/schools";

export function formatRank(rank: number | null | undefined): string {
  if (!rank || rank === 0) return "NR";
  return `#${rank}`;
}

export function formatScoringAvg(avg: number | null | undefined): string {
  if (avg == null) return "--";
  return avg > 0 ? `+${avg.toFixed(2)}` : avg.toFixed(2);
}

export function formatCurrency(value: number | null | undefined): string | null {
  if (value == null) return null;
  return `$${value.toLocaleString()}`;
}

export function formatPercent(value: number | null | undefined): string | null {
  if (value == null) return null;
  return `${Math.round(value * 100)}%`;
}

export function formatEnrollment(value: number | null | undefined): string | null {
  if (value == null) return null;
  return value.toLocaleString();
}

export function formatSATRange(admissions: CollegeDetail["admissions"]): string | null {
  const r25 =
    (admissions?.sat_scores?.reading_25th ?? 0) + (admissions?.sat_scores?.math_25th ?? 0);
  const r75 =
    (admissions?.sat_scores?.reading_75th ?? 0) + (admissions?.sat_scores?.math_75th ?? 0);
  if (!r25 || !r75) return null;
  return `${r25}\u2013${r75}`;
}

export function formatACTRange(admissions: CollegeDetail["admissions"]): string | null {
  const lo = admissions?.act_scores?.cumulative_25th;
  const hi = admissions?.act_scores?.cumulative_75th;
  if (lo == null || hi == null) return null;
  return `${lo}\u2013${hi}`;
}
